<template>
    <div class="stay__head">
        <div class="stay__container container">
            <div class="stay__counter">
                {{total}} Result{{total == 1 ? '' : 's'}}
            </div>
            <div class="stay__filter" @click="active = true">
                Filter
                <svg width="512px" height="512px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                    <path d="M238.627,496H192V253.828l-168-200V16H480V53.612l-160,200V414.627ZM224,464h1.373L288,401.373V242.388L443.51,48H60.9L224,242.172Z" class="ci-primary" />
                </svg>
            </div>
            <div class="filters" :class="{ 'visible' : active }">
                <div class="filters__head">
                    <div class="filters__title">Filter</div>
                    <button class="filters__close" @click="active = false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17.678" height="17.678" fill="#009dbb" viewBox="0 0 18 18"><path d="M16.97 2.122L2.121 16.971a1 1 0 1 1-1.414-1.414L15.556.708a1 1 0 1 1 1.414 1.414z" /><path d="M15.556 16.97L.707 2.121A1 1 0 1 1 2.121.707L16.97 15.556a1 1 0 1 1-1.414 1.414z" /></svg>
                    </button>
                </div>
                <div class="filters__body">
                    <product-filter-button :key="buttonKey(button)" v-for="button in buttons" v-model="value[buttonKey(button)]"
                                           :product="product" :filter-name="button"></product-filter-button>
                    <product-filter-dates v-if="dates" v-model="value['dates']"></product-filter-dates>
                    <div class="dropdown" v-if="!empty"><button class="button button_stroke" @click="clearFilters"><i class="fas fa-times"></i></button></div>
                    <div class="showresults" v-if="!empty">
                        <button class="button" @click="active = false">Show Results ({{total}})</button>
                    </div>
                </div>
            </div>
            <div class="stay__view pointer">
                <a v-if="showMap" @click="toggleMap"><span>View On Map</span><span>Close Map View</span></a>
            </div>
        </div>
    </div>
</template>
<script>
    import productFilterButton from './productFilterButton'
    import productFilterDates from './productFilterDates'
    export default {
        components: {
            productFilterButton,
            productFilterDates
        },
        props: {
            total: Number,
            product: String,
            empty: Boolean,
            dates: Boolean,
            buttons: Array,
            showMap: Boolean,
            value: Object,
        },
        data() {
            return {
                active: false,
                selected: []
            }
        },
        watch: {
            active() {
                this.$emit('toggleopen', this.active)
            }
        },
        methods: {
            buttonKey(b) {
                return b.replace(' ', '').toLowerCase()
            },
            toggleMap() {
                this.$emit('togglemap')
            },
            clearFilters() {
                this.$emit('clearfilters')
            },
        },
    }
</script>